import { NgModule } from '@angular/core';
import { DialogDisplayService } from './dialog-display.service';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

@NgModule({
  providers: [DialogDisplayService],
  imports: [MatDialogModule],
})
export class DialogDisplayModule {}
